// extracted by extract-css-chunks-webpack-plugin
module.exports = {"breadcrumbs":"css-a9baeygfaY","breadcrumbs_links":"css-3xohSnTOb4","breadcrumbs_link":"css-yvSxU44wC0"};